import React, { useEffect, useState } from "react";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Switch from "@material-ui/core/Switch";
import Modal from "@material-ui/core/Modal";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Pexels from "../../img/avi.png";
import "./chat.css";
import UserService from "../../services/user.service";
// import ReactTimeAgo from "react-time-ago";
import { baseURL } from "../../common/constants.js";
import MessageService from "../../services/message.service";

function rand() {
	return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
	const top = 50 + rand();
	const left = 50 + rand();

	return {
		top: `${top}%`,
		left: `${left}%`,
		transform: `translate(-${top}%, -${left}%)`,
	};
}

const StyledBadge = withStyles((theme) => ({
	badge: {
		backgroundColor: "#44b700",
		color: "#44b700",
		boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
		"&::after": {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			borderRadius: "50%",
			animation: "$ripple 1.2s infinite ease-in-out",
			border: "1px solid currentColor",
			content: '""',
		},
	},
	"@keyframes ripple": {
		"0%": {
			transform: "scale(.8)",
			opacity: 1,
		},
		"100%": {
			transform: "scale(2.4)",
			opacity: 0,
		},
	},
}))(Badge);

const useStyles = makeStyles((theme) => ({
	paper: {
		position: "absolute",
		width: 400,
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
	},

	chatMessage: {
		width: "100%",
		display: "flex",
		padding: "5px",
		backgroundColor: "#fff",
		color: "#111",
		border: "1px solid rgba(144, 25, 25, 0.1)",
		borderRadius: "10px",
		marginBottom: "5px",
		"&:hover": {
			backgroundColor: "#901919",
			color: "#fff",
			cursor: "pointer",
		},
	},
	chatImage: {
		width: "15%",
	},
	chatContent: {
		width: "80%",
		// padding: '6px',
		fontSize: "12px",
	},
	chatUsername: {
		fontSize: "14px",
		fontWeight: "bold",
	},
	chatBottomIcon: {
		display: "flex",
		justifyContent: "space-between",
	},
	avatarImage: {
		marginTop: "10px",
	},
	moreIcon: {
		color: "#333",
	},
	badge: {
		marginLeft: "15px",
		// color: '#00695f'
	},
	timeStamp: {
		display: "flex",
		justifyContent: "flex-end",
	},
}));

const Chat = ({ currentUser, conversation }) => {
	const classes = useStyles();
	const [contactUser, setContactUser] = useState(null);
	const [messageNotify, setMessageNotify] = useState(null);

	// console.log(messageNotify)

	useEffect(() => {
		const controller = new AbortController();
		const signal = controller.signal;

		const contactId = conversation?.members.find((m) => m !== currentUser._id);
		(async () => {
			if (contactId) {
				const res = await UserService.getAuser(contactId, signal);
				setContactUser(res.user);
			}
		})();

		return () => controller.abort();
	}, [conversation, currentUser]);

	useEffect(() => {
		const controller = new AbortController();
		const signal = controller.signal;

		(async () => {
			if (conversation) {
				const res = await MessageService.getNotify(conversation._id, signal);
				setMessageNotify(res.messageAlert);
			}
		})();
		return () => controller.abort();
	}, [conversation]);

	const [modalStyle] = useState(getModalStyle);
	const [open, setOpen] = useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const [state, setState] = useState({
		checkedB: true,
	});

	const handleChange = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
	};

	const body = (
		<div style={modalStyle} className={classes.paper}>
			<div className={classes.profileBox}>
				<p id="simple-modal-description">View Profile</p>
				<p id="simple-modal-description1">Delete Chat </p>
				<p id="simple-modal-description2">
					{" "}
					Mute Chat
					<Switch
						checked={state.checkedB}
						onChange={handleChange}
						color="primary"
						name="checkedB"
						inputProps={{ "aria-label": "primary checkbox" }}
					/>
				</p>
				<p id="simple-modal-description3"> Mark Unread </p>
				<p id="simple-modal-description4">Mark as Favourite</p>
			</div>
		</div>
	);

	return (
		<>
			<div className={classes.chatMessage}>
				<div className={classes.chatImage}>
					<StyledBadge
						overlap="circular"
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "right",
						}}
						// variant="dot"
					>
						{contactUser && contactUser.avatar ? (
							<Avatar
								alt="User Avatar"
								src={`${baseURL}/avatar/image/${contactUser?.avatar}`}
								className={classes.avatarImage}
							/>
						) : (
							<Avatar alt="User Avatar" src={Pexels} className={classes.avatarImage} />
						)}
					</StyledBadge>

					<div className={classes.chatBottomIcon}>
						<IconButton onClick={handleOpen}>
							<MoreHorizIcon type="button" className={classes.moreIcon} />
						</IconButton>
					</div>

					<Modal
						open={open}
						onClose={handleClose}
						aria-describedby="simple-modal-description"
					>
						{body}
					</Modal>
				</div>

				<div className={classes.chatContent}>
					<div className={classes.chatUsername}>
						{contactUser && contactUser.firstname + " " + contactUser.lastname}
						<Badge className={classes.badge} badgeContent={4} color="primary"></Badge>
					</div>

					<p className={classes.chatText}>Welcome to UBEC Chat</p>
					{/* <div className={classes.timeStamp}>Just now</div> */}
				</div>
			</div>
		</>
	);
};

export default Chat;
